import { SearchUtils } from '@spotify/confidence-core-react';
import {
  TaskFragment,
  TaskQuery,
  TaskQueryVariables,
  useOnTaskUpdatedSubscription,
  useTaskSuspenseQuery,
  withStandardGetSuspenseHook,
} from '@spotify/confidence-graphql';

const useTaskSuspenseImpl = withStandardGetSuspenseHook<
  TaskQuery,
  TaskFragment,
  'task',
  TaskQueryVariables
>(useTaskSuspenseQuery, 'task');

export const useTaskSuspense: typeof useTaskSuspenseImpl = options => {
  useOnTaskUpdatedSubscription({
    variables: {
      filter: `task.name:${SearchUtils.escapeQuery(options.name)}`,
    },
  });

  return useTaskSuspenseImpl(options);
};
